import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { getCurrentPlaceId } from '../lib/placeConfig'

/**
 * Redirects /app to /app/:defaultPlaceId/orders.
 * Use when user navigates to /app without a placeId (e.g. after login).
 * Waits for userProfile so we never redirect to another account's place (e.g. env default).
 */
export default function RedirectToDefaultPlace() {
  const auth = useAuth()

  if (auth?.loading || !auth?.user) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        Loading…
      </div>
    )
  }

  // Do not redirect until we have the current user's profile (defaultPlaceId).
  // Otherwise we might use getCurrentPlaceId() which could be env/default and leak to another place.
  if (!auth.userProfile?.defaultPlaceId) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        Loading…
      </div>
    )
  }

  const defaultPlaceId = auth.userProfile.defaultPlaceId ?? getCurrentPlaceId()
  return <Navigate to={`/app/${defaultPlaceId}/orders`} replace />
}
